import React from 'react';
import { connect } from "react-redux";
import createPorezi from './../../../../API/Provider/CreateTaxRate'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from './../../../../Global/loader'
import GetCountries from './../../../../API/Provider/GetProviderCountries'
import Select from 'react-select'
import { withNamespaces } from 'react-i18next';
import { Form, Row, Col, Button } from 'react-bootstrap'

class CreatePorezi extends React.Component {
    constructor(props) {
        super(props); 
        this.submitCreate = this.submitCreate.bind(this);
    }

    state={
        loading: false,

        label: "",
        description: "",
        tax_rate: 0,
        countries: [],
        country: null,
        note: ""
    }

    componentDidMount = async () => {
        document.title = this.props.t("Tax Rate") + "-" + this.props.t("Create")

        let data = { 
            pageSize: 1000,
            activePage: 1,
            activeOnly: 0,
            sortDirection: 0,
            search: {
                searchFor: ""
            },
            sortBy: {
                id: 0
            }
        }
        
         //get countries
         let items = await GetCountries(data)       
         let countryList = []
         
         await items.data.countries
             .map((data, index) =>{
             let oneItem = {value: data.uuid , label: data.country_name }
             countryList.push(oneItem)
             return null
         })
             
         await this.setState({
             countries: countryList,
             country: countryList[0]
         })
 
         await this.setState({
             loading: false            
         })
    }

    handleChange(e){
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    submitCreate = async (e) => {   
        this.setState({ loading: true })
        e.preventDefault()        

        let createPP = await createPorezi(         
            this.state.label,
            this.state.description,
            this.state.tax_rate,
            this.state.country.value,
            this.state.note
        )

        if(createPP.data.status === 200){ 
            store.addNotification({
                title: this.props.t('Success!'),
                message: this.props.t("Creating was successful"),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.setState({ loading: false })
            this.props.goBack()
        }
        else{
            store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t("There was an error creating the Tax, please try again"),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        
    }

    handleCountryChange(e){  
        this.setState({
            country: e
        })                  
    }
   
    render(){  
        const { t } = this.props
        
        return (
            <div>
                {this.state.loading ?
                    <Loader />
                :
                <Form className="form-container">
                    <Row>        
                        <Col sm={12} lg={6} xl={4}>
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="country" column sm={2} md={4}>{t('Country')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Select
                                        options={this.state.countries} 
                                        onChange={(values) => this.handleCountryChange(values)}
                                        isInvalid={this.state.country === null}
                                        value={this.state.country}
                                    />                                  
                                </Col>
                            </Form.Group>
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="label" column sm={2} md={4}>{t('Form.Label')}</Form.Label>
                                <Col sm={10} md={8}>
                                   <Form.Control        
                                            id="label"                          
                                            type="text"
                                            value={this.state.label}
                                            onChange={e => this.handleChange(e)}
                                        />
                                </Col>
                            </Form.Group>
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="description" column sm={2} md={4}>{t('Description')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="description"  
                                        type="text"
                                        value={this.state.description}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="tax_rate" column sm={2} md={4}>{t('Tax Rate')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        className="input-number-without-arrows"
                                        id="tax_rate"  
                                        type="number"
                                        min={0}
                                        value={this.state.tax_rate && Math.max(0, this.state.tax_rate)}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="note" column sm={2} md={4}>{t('Note')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="note"  
                                        type="text"
                                        value={this.state.note}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                            <Col sm={12} className="button-container">
                                <Button    
                                    className="btnSpremi"
                                    onClick={(e) => this.submitCreate(e)}
                                >
                                    {t('Save')}
                                </Button>
                            </Col>                                 
                        </Col>
                    </Row>           
                    
                    <Row className='back-button-container'>
                        <Button 
                            variant='default'
                            onClick={() => this.props.goBack()}
                        >
                            <BsBackspaceFill size={30} />  <strong>{t('Back')}</strong>
                        
                        </Button>
                    </Row>
                </Form>
                }
            </div>

        )
    }
}
const mapStateToProps = state => {
    return {
        oneProvider: state.provider.oneProvider
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(CreatePorezi));